












































































import { Dialog, Button } from 'element-ui'
import NProgress from 'nprogress'
import { Printd } from 'printd'
import { mixins } from 'vue-class-component'
import { Vue, Component, Ref } from 'vue-property-decorator'
import { Location, Route } from 'vue-router'

import BookingTopNav from '@/components/BookingTopNav.vue'
import CreditNoteList from '@/components/CreditNoteList/CreditNoteList.vue'
import CreditNoteWidget from '@/components/CreditNoteWidget.vue'
import LoadingPlaceholder from '@/components/LoadingPlaceholder.vue'

import Booking from '@/models/booking'
import CreditNote from '@/models/credit-note'
import Passenger from '@/models/passenger'
import Payment from '@/models/payment'

import BookingHeaderTitleMixin from '@/mixins/BookingHeaderTitleMixin.vue'
import { BookingsActionTypes } from '@/store/modules/bookings'
import { CreditNoteActionTypes } from '@/store/modules/creditNotes'

import creditNoteListStyles from '!css-loader!sass-loader!@/components/CreditNoteList/styles.scss'

@Component({
  components: {
    BookingTopNav,
    CreditNoteList,
    CreditNoteWidget,
    [Dialog.name]: Dialog,
    [Button.name]: Button,
    LoadingPlaceholder,
  },
})
export default class CreditNotesPage extends mixins(BookingHeaderTitleMixin) {
  @Ref() readonly printableCreditNote!: CreditNoteList

  printedCreditNote: CreditNote | null = null

  mounted() {
    this.initialSetup(this.$route.params.id)
  }

  beforeRouteUpdate(to: Route, from: Route, next: (to?: Location) => void) {
    this.initialSetup(to.params.id)
    next()
  }

  initialSetup(bookingId: string) {
    NProgress.start().set(0.3)
    this.$store.dispatch(BookingsActionTypes.Get, bookingId)
    NProgress.set(0.6)
    this.$store.dispatch(CreditNoteActionTypes.LoadByBookingId, bookingId)
    NProgress.done()
  }

  printCreditNote() {
    const printer: Printd = new Printd()
    printer.print(
      this.printableCreditNote.$el as HTMLElement,
      creditNoteListStyles.toString(),
    )
  }

  get booking(): Booking {
    return this.$store.getters.getBooking(this.$route.params.id)
  }

  get creditNotesLoaded(): boolean {
    return this.$store.state.creditNotes.creditNoteLoaded
  }

  get creditNotes(): CreditNote[] {
    if (!this.booking) {
      return []
    }
    const creditNotes = this.$store.getters.getCreditNotesByIds(
      this.booking.creditNoteIds,
    )
    return creditNotes
  }

  get passengerEntities(): { [id: number]: Passenger } {
    return this.$store.state.passengers.passengerEntities
  }

  get passengers(): Passenger[] {
    return this.$store.getters.getPassengersByIds(this.booking.passengerIds)
  }

  getCreditNoteRefunds(creditNote: CreditNote): Payment[] {
    return this.$store.getters.getPaymentsByIds(creditNote.refunds)
  }
}
